<template>
  <!-- 咨询付款页面 -->
  <div id="inquiry">
    <header>
      <div class="top-title">
        <img src="../../assets/img/login-img/3-1档案-返回ic@2x.png" alt="" class="back-icon" @click="goback">
        <p class="title-text">咨询{{doctorName||'三甲'}}医生</p>
      </div>
    </header>
    <div class="content-box">
      <!-- 问题描述 -->
      <div class="quest-box">
        <span class="title-name">问题描述</span>
        <textarea v-model="question" maxlength="500" placeholder="请简要描述您的症状，便于医师分析您的情况..."
                  class="input-text"></textarea>
        <span class="total-tips">{{textNum}}/500</span>
      </div>
      <!-- end -->
      <!-- 就诊人信息 -->
      <div class="user-msg">
        <p class="title-name">就诊人信息</p>
        <p class="title-tips">请提供患者身份信息，利于医生做出准确判断</p>
        <div class="scroll-box">
          <ul class="user-file">
            <li class="file-list-flag" @click="goRouter('/SdAddfile')">
              <img src="../../assets/img/common-img/add@2x.png" alt="" class="add-img">
              <span class="list-tips">添加就诊人</span>
            </li>
            <li class="file-list" :class="{selectFile:fileSelect === item.id}" v-for="(item,index) in healthFile"
                :key="index" @click="selectFile(item,index)">
              <span class="list-header">{{item.name}}</span>
              <div class="list-tips">
                <span>{{item.sex|sexFilter}}</span>
                <span class="tips-flag">|</span>
                <span>{{item.age}}</span>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <!-- end -->
      <!-- 服务说明 -->
      <div class="service-description">
        <p class="title-name">服务说明</p>
        <div v-if="!(doctorData.is_famous_doctor === 'n' || doctorData.is_famous_doctor === 'y')">
          <p class="title-tips">由三甲医院医生为您提供咨询服务;</p>
          <p class="title-tips">医生会在3分钟内回复您，如遇特殊情况会有所延迟，超过1小时未回复将自动退款。</p>
          <p class="title-tips">24小时以内可以与医生互动咨询20次（从您提出问题，到医生回复计为一次互动咨询）。</p>
        </div>
        <ul v-if="doctorData.is_famous_doctor === 'n' || doctorData.is_famous_doctor === 'y'">
          <li class="title-tips">
            <span>医生会尽快回复您，如遇特殊情况会有所延迟；</span>
          </li>
          <li class="title-tips">
            <span>超过4小时未回复将自动退款；</span>
          </li>
          <li class="title-tips">
            <span>{{severText}}</span>
          </li>
        </ul>
      </div>
      <!-- end -->
    </div>
    <!-- 底部 -->
    <div class="bottom">
      <div class="box-bottom">
        <!--阴影 -->
        <div class="bottom-shadow"></div>
        <!-- end -->
        <div class="bottom-button">
          <!-- 小程序 -->
          <van-button v-if="isMinProgamme" size='large' class="right-button" @click="payMoney">提交问题</van-button>
          <!-- 微信h5 或者 移动浏览器 -->
          <van-button v-else size='large' class="right-button" @click="payMoney">提交问题并支付{{price?price/100 : ''}}元 </van-button>
          <!-- <van-button size='large' class="right-button" @click="payMoney">提交问题并支付{{((doctorData.price || rePayprice)/100)|priceFilter}}元</van-button> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
  /* eslint-disable */
  import wx from 'weixin-js-sdk'
  import SdPayMethod from '../shenduPayAlert/SdPayMethod'
  import SdPayStatus from '../shenduPayAlert/SdPayStatus'
  import {currentHost} from "@/config"
  import {isMiniProgamme} from "@/common/util"
  import api from '@/api/index'

  export default {
    data() {
      return {
        showPayMethod: false,
        showPayStatus: false,
        orderNum: '',
        oldOrderNum: "",
        question: '',
        doctorData: '',
        healthFile: [],
        fileSelect: '',
        fileId: '',  //档案id
        isPayMoney: '',
        http: '',
        prepayId: '',
        textNum: 0,
        payFlag: true,
        ask_id: '',
        doctorName: '',
        orderItem: {},
        rePayPrice: '',
        upPrice: '',
        doctor_id: '',
        backPath: null, //返回的地址
        payStatusTimer: null,
        isMinProgamme: false // 是否小程序 环境
      }
    },
    created() {
      if (this.$route.query.doctor_id) {
        //如果为定向 获取医生数据
        this.doctor_id = this.$route.query.doctor_id
        this.updateDoctor(this.doctor_id)
      }
      this.fetch()
      this.fetchHealth()
      if (localStorage.getItem('askData') !== '' && !this.$route.query.order_number) {
        this.question = localStorage.getItem('askData')
      }
    },
    mounted() {
      const self = this
      isMiniProgamme().then(res=>{
        self.isMinProgamme = res // 是否在小程序里面
      })
      //如果为从新支付订单 获取从新支付详情
      if (this.$route.query.order_number) {
        this.oldOrderNum = this.$route.query.order_number
        this.fetchRePay(this.oldOrderNum)
      }
    },
    destroyed() {
      //离开页面清空输入的问题
      if (this.question) {
        if (this.question.length > 0) {
          localStorage.setItem('askData', '')
          localStorage.setItem('askData', this.question)
        }
      }
    },
    watch: {
      //输入问题字数下标
      question: {
        handler(n, o) {
          if (n) {
            if (this.textNum > 500) {
              this.$toast('字数超过限制')
              this.payFlag = false
              this.textNum = n.length
            } else {
              this.payFlag = true
              this.textNum = n.length
            }
          }
        }
      },
      fileId: {
        handler(n, o) {
          this.fileSelect = n
        },
        immediate: true
      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        let path = from.path
        sessionStorage.setItem('askPath', path)
        vm.backPath = from.path
      })
    },
    beforeDestroy() {
      if (this.payStatusTimer) {
        clearInterval(this.payStatusTimer)
      }
    },
    methods: {
      goback() {
        if (this.$route.query.from) {
          this.$router.push(this.$route.query.from)
        } else {
          this.$router.go(-1)
          //this.$router.push('/SdAskDoctor')
        }
      },
      goRouter(val) {
        this.fileSelect = ''
        this.$router.push(val)
      },
      wechatPayCheck(order_number) {
        let step = 0
        this.payStatusTimer = setInterval(() => {
          this.$http.get(api.selectOrderStatus, {
            params: {order_number}
          }).then(res => {
            const {is_pay, trade_status} = res.data.data
            if (step > 5 * 60) {
              this.$toast("支付超时")
              this.$router.push('/SdAskOrder')
              return
            }
            if (is_pay && trade_status == 1) {
              clearInterval(this.payStatusTimer)
              this.$toast("支付成功")
              this.skipAskDoctorChat()
              return
            }
            step += 1
          })
        }, 1000)
      },
      // 手机浏览器支付
      mobileBrowserPay(isRepay) {
        const {doctor_id} = this.$route.query
        let params = {
          ask_group_type: doctor_id ? 2 : 1, //1 众包 2 定向
          xz_doctor_id: doctor_id ? doctor_id : null,
          question: this.question,
          health_record_id: this.fileId,
          order_type: 3, //1 pc 2 weixin, 3 mobileBrowser
        }
        if (isRepay && this.oldOrderNum) {
          params.ask_group_type = this.orderItem.ask_group_type
          params.is_old_order = 1
          params.old_order_number = this.oldOrderNum
          params.xz_doctor_id = this.doctor_id
        }
        console.log(params)
        const url = api.createWzOrder
        this.$http.post(url, this.$ObjToFd(params)).then(res => {
          if (res.data.code == 0) {
            const mweb_url = res.data.data.config.result.mweb_url
            const order_number = res.data.data.order_number
            this.orderNum = order_number
            console.log(mweb_url + "&redirect_url=" + encodeURIComponent(currentHost + '/#/payCheck/' + order_number + '/doctor'))
            location.href = mweb_url + "&redirect_url=" + encodeURIComponent(currentHost + '/#/payCheck/' + order_number + '/doctor')
          }
        })
      },
      // 2019年5月28日21:34:30 周熙孟 临时代码，处理获取不到openid的bug
      urlOpenId() {
        let http = window.location.href
        console.log('openid http2',http)
        // console.log(!!http.indexOf('openid'), '如果为真的话我就去截取openid哦 false的话说明当前地址没有openid我就要去跳转了吖')
        if (http.indexOf('openid') > -1) {
          let openid = http.split('openid')[1].split('#')[0]
          if (openid) {
            let id = openid.split('=')[1]
            localStorage.setItem('openid', id)
            return id
            console.log('临时解决方案get openid', id)
            // 还有一种情况要考虑的：openid不在本地，也不在url的时候
          }
          next()
        } else {
          let url = val.split('/')[1]
          // window.location.href = `https://test.shendutv.com/wx/tz?url=${url}` // 测试环境
           window.location.href = location.origin + `/wx/tz?url=${encodeURIComponent(url)}` //正式环境
        }
      },
      // 微信支付
      weixinPay(isRepay) {
        const {doctor_id} = this.$route.query
        let params = {
          ask_group_type: doctor_id ? 2 : 1, //1 众包 2 定向
          xz_doctor_id: doctor_id ? doctor_id : null,
          question: this.question,
          health_record_id: this.fileId,
          order_type: 2, //1 pc 2 weixin, 3 mobileBrowser
          openid: localStorage.getItem('openid') || this.urlOpenId()
        }
        if (isRepay && this.oldOrderNum) {
          params.ask_group_type = this.orderItem.ask_group_type
          params.is_old_order = 1
          params.old_order_number = this.oldOrderNum
          params.xz_doctor_id = this.doctor_id
        }
        console.log(params)
        const url = api.createWzOrder
        this.$http.post(url, this.$ObjToFd(params)).then(res => {
          if (res.data.code == 0) {
            const {prepayId, json} = res.data.data.config
            const order_number = res.data.data.order_number
            this.orderNum = order_number
            if (WeixinJSBridge && prepayId !== '') {
              // 下单成功 WeixinJSBridge
              WeixinJSBridge.invoke('getBrandWCPayRequest', json, (
                res
              ) => {
                if (res.err_msg === 'get_brand_wcpay_request:ok') {
                  this.wechatPayCheck(order_number) //
                } else {
                  this.$router.push('/SdAskOrder')
                  this.$toast('支付失败')
                }
              })
            }
          }
        })
      },
      // 小程序支付
      miniProgPay(isRepay) {
        const {doctor_id} = this.$route.query
        let params = {
          ask_group_type: doctor_id ? 2 : 1, //1 众包 2 定向
          xz_doctor_id: doctor_id ? doctor_id : null,
          question: this.question,
          health_record_id: this.fileId,
          order_type: 4, //1 pc 2 weixin, 3 mobileBrowser 4 小程序)
          openid: localStorage.getItem('miniOpenid')
        }
        if (isRepay && this.oldOrderNum) {
          params.ask_group_type = this.orderItem.ask_group_type
          params.is_old_order = 1
          params.old_order_number = this.oldOrderNum
          params.xz_doctor_id = this.doctor_id
        }
        // alert(localStorage.getItem('miniOpenid'))
        console.log(params)
        params['token'] = localStorage.getItem('token')
        wx.miniProgram.navigateTo({ url: '/pages/miniPay/miniPay?' + this.parseQuery(params)})
        return 
        const url = api.createWzOrder
        this.$http.post(url, this.$ObjToFd(params)).then(res => {
          if (res.data.code == 0) {
            const {prepayId, json} = res.data.data.config
            const order_number = res.data.data.order_number
            this.orderNum = order_number

            json.package = json.package.replace("prepay_id=", '')
            // alert('/pages/minPay/minPay?' + this.parseQuery({
            //   ...json,
            //   prepayId,
            //   orderNum: order_number,
            //   ask_group_type: doctor_id ? 2 : 1, //1 众包 2 定向
            // }))
            //"pages/miniPay/miniPay"
            wx.miniProgram.navigateTo({ url: '/pages/miniPay/miniPay?' + this.parseQuery({
                ...params
                //...json,
                //prepayId,
                //orderNum: order_number,
                //price: this.price,
                //ask_group_type: doctor_id ? 2 : 1, //1 众包 2 定向
              })
            })
           /* if (WeixinJSBridge && prepayId !== '') {
              // 下单成功 WeixinJSBridge
              WeixinJSBridge.invoke('getBrandWCPayRequest', json, (
                res
              ) => {
                if (res.err_msg === 'get_brand_wcpay_request:ok') {
                  this.wechatPayCheck(order_number) //
                } else {
                  this.$router.push('/SdAskOrder')
                  this.$toast('支付失败')
                }
              })
            }*/
          }
        })
      },
      //  把 json 转成 url ?a=xx&b=xxx
      parseQuery(query) {
        if( typeof query != 'object' ) {
          return ''
        }
        var paramStr =  ""
        for (let key in query) {
          if( query[key] ) {
            paramStr += "&" + key + "=" + query[key]
          }
        }
        return paramStr.substr(1)
      },
      skipAskDoctorChat() {
        this.$router.push({
          path: '/SdAskChat',
          query: {orderId: this.orderNum}
        })
      },
      payMoney() {
        if (this.$route.query.order_number) {
          //query含有order_number为从新支付
          this.rePayMoney()
        } else {
          if (this.payFlag) {
            if (this.fileId !== '') {
              if (this.question === null || this.question.length < 20) {
                this.$toast('问题不够详细，字数不能小于20')
              } else {
                /******************/
                if( this.isMinProgamme ) {
                  // 小程序支付
                  this.miniProgPay()
                  return
                }
                if (this.$isWexin && !this.isMinProgamme) {
                  // 微信支付
                  this.weixinPay()
                }
                else {
                  // 手机浏览器
                  this.mobileBrowserPay()
                }
                return
                /**************************/
              }
            } else {
              this.$toast('请选择健康档案')
            }
          } else {
            this.$toast('支付失败请检查')
          }
        }
        // this.showPayMethod = true
      },
      closePop(val) {
        this.showPayMethod = val
      },
      fetch() {
        //获取医生详情
        if (this.$route.query.doctor_id) {
          let id = this.$route.query.doctor_id
          let url = `${api.doctorDetail}?doctor_id=${id}`
          this.$http.get(url).then(res => {
            if (res.data.code == '0') {
              this.doctorData = res.data.data
              this.doctorName = this.doctorData.name
            }
          })
        }
      },
      // 获取健康档案
      fetchHealth() {
        let url = api.healthRecordsList
        this.$http.get(url).then(res => {
          if (res.data.code == 0) {
            this.healthFile = res.data.data
            this.healthFile.reverse()
            if (this.healthFile.length > 0) {
              this.fileId = this.healthFile[0].id
            }
          }
        })
      },
      // 选择健康档案
      selectFile(item, index) {
        this.fileSelect = item.id
        this.fileId = item.id
      },
      // 创建众包问题
      creatProblem(type) {
        let url = api.createPaidProblem
        let params = {
          order_number: this.orderNum,
          question: this.question,
          ask_type: 'text',
          health_record_id: this.fileId,
          qxdd: type
        }
        this.$http.post(url, this.$ObjToFd(params)).then(res => {
          if (res.data.code == 0 || res.data.code == '0') {
            if (type === 'n') {
              this.question = ''
              localStorage.removeItem('askData')
              this.$router.push({
                path: '/SdAskChat',
                query: {orderId: this.orderNum}
              })
            }
          } else {
            this.$toast(res.data.message)
          }
        })
      },
      // 创建定向问题
      creatOrientedProblem(type) {
        let url = api.createOrientedProblem
        let params = {
          order_number: this.orderNum,
          question: this.question,
          ask_type: 'text',
          doctor_id: this.$route.query.doctor_id,
          // doctor_id: this.$route.query.doctor_id,
          health_record_id: this.fileId,
          qxdd: type
        }
        this.$http.post(url, this.$ObjToFd(params)).then(res => {
          if (res.data.code == 0 || res.data.code == '0') {
            if (type === 'n') {
              this.question = ''
              localStorage.removeItem('askData')
              this.$router.push({
                path: '/SdAskChat',
                query: {orderId: this.orderNum}
              })
            }
          } else {
            this.$toast(res.data.message)
          }
        })
      },
      // 获取从新支付的详情
      fetchRePay(val) {
        let params = {
          order_number: val
        }
        let url = `${api.orderInfoRepay}?order_number=${params.order_number}`
        this.$http.get(url).then(res => {
          if (res.data.code == 0) {
            let firstAsk = res.data.data.firstAsk
            let healthFile = res.data.data.healthRecord
            this.question = firstAsk.question
            this.orderItem = res.data.data.askGroupsModel
            // this.fileId = healthFile.id
            this.ask_id = firstAsk.id //! !!!!
            this.doctorName = firstAsk.doctor_name
            this.rePayPrice = res.data.data.order.order_amount
            if (res.data.data.askGroupsModel.ask_group_type === '2') {
              this.doctor_id = res.data.data.askGroupsModel.xz_doctor_id
              this.updateDoctor(this.doctor_id)
            }
          }
        })
      },
      // 重新微信支付
      rePayMoney() {
        const isRepay = true
        if (this.$isWexin && !this.isMinProgamme ) {
          // 微信支付
          this.weixinPay(isRepay)
        }
        else if( this.isMinProgamme ) {
          this.miniProgPay(isRepay)
        }
        else {
          // 手机浏览器
          this.mobileBrowserPay(isRepay)
        }
      },
      // 创建总包从新支付
      creatZbSecond() {
        let url = api.createPaidProblemSecond
        let params = {
          order_number: this.orderItem.order_number
        }
        this.$http.post(url, this.$ObjToFd(params)).then(res => {
          if (res.data.code == '0') {
            this.$router.push({path: '/SdAskChat', query: {orderId: this.orderItem.order_number}})
            this.$toast('重新支付成功')
          }
        })
      },
      // 创建定向从新支付
      creatDxSecond() {
        let url = api.createOrientedProblemSecond
        let params = {
          order_number: this.orderItem.order_number,
          xz_doctor_id: this.orderItem.xz_doctor_id
        }
        this.$http.post(url, this.$ObjToFd(params)).then(res => {
          if (res.data.code == '0' || res.data.code == 0) {
            this.$toast('重新支付成功')
            this.$router.push({path: '/SdAskChat', query: {orderId: this.orderItem.order_number}})
          } else {
            this.$toast(res.data.message)
          }
        })
      },
      // 更新医生信息
      updateDoctor(val) {
        let params = {
          doctor_id: val
        }
        let url = `${api.updateDoctor}?doctor_id=${params.doctor_id}`
        this.$http.get(url).then(res => {
          if (res.data.code == 0 || res.data.code == '0') {
            if (res.data.data.cy_close === true) {
              this.$toast('该医生已关闭问诊服务,选择其他医生咨询吧~')
              let time = setTimeout(() => {
                this.$router.push('/SdAskDoctor')
              }, 500)
            } else {
              this.upPrice = res.data.data.price
            }
          }
        })
      }
    },
    computed: {
      severText() {
        return this.doctorData.is_famous_doctor === 'y'
          ? '48小时以内可以与医生互动咨询10次（从您提出问题，到医生回复计为一次互动咨询）。'
          : '48小时以内可以与医生互动咨询50次（从您提出问题，到医生回复计为一次互动咨询）。'
      },
      price() {
        if (this.upPrice !== '') {
          return this.upPrice
        } else {
          if (this.doctorData.price) {
            return this.doctorData.price
          } else if (this.rePayPrice) {
            return this.rePayPrice
          } else {
            if (this.$route.query.doctor_id) {
              return ''
            }
            else {
              return 990
            }

          }
        }
      }
    },
    filters: {
      priceFilter(val) {
        // if (this.rePayPrice) {
        //   return this.rePayPrice
        // } else {
        return val || 9.9
        // }
      },
      sexFilter(val) {
        return val === 'm' ? '男' : '女'
      }
    }
  }
</script>

<style lang="postcss">
#inquiry {
  height: 100%;
  & .top-title {
    padding: 27px 0;
    position: fixed;
    width: 100%;
    z-index: 999;
    display: flex;
    justify-content: center;
    border-bottom: 1px solid #fffffd;
    background-color: #fffffd;
    box-shadow: 1px 8px 60px rgba(0, 0, 0, 0.1);
    & .back-icon {
      width: 17px;
      height: 34px;
      position: absolute;
      left: 30px;
    }
    & .title-text {
      font-size: 34px;
      font-family: "SourceHanSansCN Medium";
      font-weight: 400;
    }
  }
  & .content-box {
    /* margin: 60px 0 48px 0; */
    /* padding-top: 60px; */
    position: relative;
    top: 128px;
    /* width: 100%; */
    padding: 0 30px;
    padding-bottom: 160px;
    background-color: #fffffd;
    & .title-name {
      font-size: 36px;
      font-family: SourceHanSansCN-Bold;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
      margin-bottom: 30px;
    }
    & .quest-box {
      position: relative;
      & .input-text {
        background-color: #fffffd;
        height: 400px;
        width: 100%;
        border: 2px solid rgba(215, 215, 215, 1);
        border-radius: 10px;
        font-size: 24px;
        font-family: SourceHanSansCN-Regular;
        font-weight: 400;
        resize: none;
        /* color: rgba(153, 153, 153, 1); */
        color: black;
        margin: 30px 0 52px 0;
        padding: 20px;
        box-sizing: border-box;
        line-height: 30px;
        /* line-height: normal; */
        -webkit-appearance: none;
      }
      & .total-tips {
        position: absolute;
        bottom: 80px;
        right: 20px;
        font-size: 24px;
        font-family: SourceHanSansCN-Regular;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
      }
    }
    & .user-msg {
      & .title-tips {
        font-size: 26px;
        font-family: SourceHanSansCN-Regular;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
        margin: 30px 0 18px 0;
      }
      & .scroll-box {
        overflow: hidden;
      }
      & .user-file {
        width: 96%;
        padding: 20px;
        margin: -19px;
        display: flex;
        display: -webkit-box;
        overflow-x: scroll;
        -webkit-overflow-scrolling: touch;
        & li:last-child{
          /* background-color: red; */
          margin-right: 50px;
        }
        & .user-file::-webkit-scrollbar {
          display: none;
        }
        & .file-list-flag {
          width: 240px;
          height: 120px;
          border: 1px dashed rgba(215, 215, 215, 1);
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          & .add-img {
            width: 36px;
            height: 36px;
            margin-bottom: 15px;
          }
        }
        & .file-list {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          width: 240px;
          height: 120px;
          border: 1px solid rgba(215, 215, 215, 1);
          border-radius: 10px;
          & .list-header {
            font-size: 30px;
            font-family: SourceHanSansCN-Medium;
            font-weight: 500;
            color: rgba(51, 51, 51, 1);
            margin-bottom: 15px;
          }
        }
        & .selectFile {
          border: 1px solid rgba(55, 189, 25, 1) !important;
          background: rgba(55, 189, 25, 0.2);
          & span {
            color: rgba(55, 189, 25, 1) !important;
          }
        }
        & .list-tips {
          font-size: 24px;
          font-family: SourceHanSansCN-Regular;
          font-weight: 400;
          color: rgba(153, 153, 153, 1);
          & .tips-flag {
            margin: 0 50px;
          }
        }
        & li {
          margin-right: 30px;
        }
      }
    }
    & .service-description {
      position: relative;
      margin-top: 60px;
      padding-bottom: 50px;
      /* border-bottom: 1px solid rgba(215, 215, 215, 1); */
      & .title-tips {
        font-size: 26px;
        font-family: SourceHanSansCN-Regular;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        line-height: 48px;
      }
      &::after {
          position: absolute;
          left: 0;
          bottom: 0;
          content: '';
          display: block;
          width: 100%;
          height: 1px;
          border: 1px solid rgba(215, 215, 215, 1);
          transform: scaleY(.3);
        }
    }
  }
  & .bottom {
    position: fixed;
    bottom: 0px;
    width: 100%;
    & .box-bottom {
      & .bottom-shadow {
        width: 100%;
        background: url("../../assets/img/common-img/jianbian-xia@2x.png")
          repeat-x;
        height: 73px;
        position: fixed;
        bottom: 88px;
      }
      & .van-button--default {
        height: 88px;
        background-color: #ffffff;
        border: none;
        font-size: 32px;
        font-family: SourceHanSansCN-Medium;
        font-weight: 500;
        color: rgba(55, 189, 25, 1);
      }
    }
  }
}



</style>



// WEBPACK FOOTER //
// src/components/public/SdInquiry.vue